import { invoke } from '@shared/easyfy.decorators';
import { Grid } from '@splidejs/splide-extension-grid';
import { isMobile, isTablet, isDesktop } from '@clientShared/utils';
import SliderHelper from '@clientShared/sliderHelper';

@invoke
export default class ProductListComponent {
  static Instance: ProductListComponent;
  private static initialized: boolean = false;
  onInit() {
    ProductListComponent.refreshProductList();
    if (!ProductListComponent.initialized) {
      window.addEventListener('component-productlistupdate', (() => {
        ProductListComponent.refreshProductList(true);
      }) as EventListener);
      ProductListComponent.initialized = true;
    }
  }

  static refreshProductList = (updateAll: boolean = false, refreshMedia: boolean = false) => {
    const selector = `[data-container='productlist-scroll'][data-media="${refreshMedia ? 'true' : 'false'}"]`;
    document.querySelectorAll(selector).forEach((list) => {
      if (!(list instanceof HTMLElement)) return;
      if (!updateAll && list.classList.contains('splide')) {
        return;
      }
      if (list.querySelector('[data-worker-handler="kevel"]')) {
        return;
      }

      const columnsDesktop: number = parseInt((list as HTMLElement).getAttribute('data-columns-d') ?? '0', 10);
      const columnsTablet: number = parseInt((list as HTMLElement).getAttribute('data-columns-t') ?? '0', 10);
      const columnsMobile: number = parseInt((list as HTMLElement).getAttribute('data-columns-m') ?? '0', 10);

      const groupScroll: boolean = list.getAttribute('data-group-scroll')?.toLowerCase() === 'true';

      const numberOfCards = list.querySelectorAll('[data-container="product-card"]').length;
      const styles = getComputedStyle(list);

      const gapDesktop = parseInt(styles.getPropertyValue('--custom-gap-d') || '32', 10);
      const gapTablet = parseInt(styles.getPropertyValue('--custom-gap-t') || '24', 10);
      const gapMobile = parseInt(styles.getPropertyValue('--custom-gap-m') || '10', 10);

      if (isMobile() && numberOfCards <= columnsMobile) return;
      if (isTablet() && numberOfCards <= columnsTablet) return;
      if (isDesktop() && numberOfCards <= columnsDesktop) return;

      list.classList.add('splide');
      const slider = SliderHelper.CreateSlider(list, {
        type: 'loop',
        speed: 400,
        dragMinThreshold: 20,
        flickMaxPages: 1,
        flickPower: 100,
        snap: false,
        arrows: true,
        gap: gapDesktop,
        perPage: columnsDesktop,
        focus: groupScroll ? undefined : 0,
        padding: {
          left: 0,
          right: 0,
        },
        breakpoints: {
          1100: {
            gap: gapTablet,
            perPage: columnsTablet,
          },
          768: {
            gap: gapMobile,
            perPage: columnsMobile,
          },
        },
      });

      slider.on('mounted', () => {
        list.classList.add('slider-has-mounted');
      });

      SliderHelper.OnPaginationMounted(slider, list as HTMLElement);

      SliderHelper.MountSlider(slider);

      SliderHelper.AddSliderOverlay(list as HTMLElement);
      SliderHelper.UpdateImagesSize(slider, list as HTMLElement);
      SliderHelper.removeDuplicatedLinks(slider);

      list.classList.remove('not-initialized');
    });

    document.querySelectorAll('[data-container="productlist-scroll-compact"]').forEach((list) => {
      if (!(list instanceof HTMLElement)) return;
      list.classList.add('splide');
      const slider = SliderHelper.CreateSlider(list, {
        type: 'loop',
        focus: 0,
        perPage: 3.5,
        speed: 300,
        dragMinThreshold: 20,
        flickMaxPages: 1,
        flickPower: 100,
        pagination: true,
        snap: false,
        arrows: true,
        gap: 16,
        padding: {
          left: 2,
          right: 0,
        },
        breakpoints: {
          768: {
            arrows: false,
            perPage: 1,
            perMove: 1,
            padding: {
              left: 0,
              right: 0,
            },
            fixedHeight: 200,
            grid: {
              rows: 3,
              gap: {
                row: '16px',
                col: '',
              },
            },
          },
        },
      });

      slider.on('pagination:mounted', function handlePaginationMounted(data) {
        // if fewer slides than provided in options, hide pagination
        if (data.items.length <= (slider.options.perPage ?? Infinity)) {
          slider.options.type = 'slide';
          slider.options = {
            pagination: false,
          };
          SliderHelper.ResetSlideRoles(slider);
          if (slider.Components.Arrows.arrows.prev) slider.Components.Arrows.arrows.prev.style.display = 'none';
          if (slider.Components.Arrows.arrows.next) slider.Components.Arrows.arrows.next.style.display = 'none';
        }
        if (isMobile()) data.list.classList.add('with-dots');
        if (!isMobile()) data.list.classList.add('with-lines');
      });
      SliderHelper.MountSlider(slider, { Grid });

      if (!isMobile()) {
        SliderHelper.AddSliderOverlay(list as HTMLElement);
      }
    });
  };
}
